import Contract from "slotworks/utils/contract";

export function parallel<T>(methods: Array<() => Contract<any>>): Contract<T> {
    return new Contract<T>((resolve) => {

        let count = methods.length;

        if (!count) {
            resolve(null);
        }

        for (const method of methods) {
            method().then(() => {
                count--;

                if (count <= 0) {
                    resolve(null);
                }
            });
        }
    });
}

export function sequence<T>(methods: Array<() => Contract<any>>): Contract<T> {
    return new Contract<T>((resolve) => {
        const next = () => {
            if (!methods.length) {
                resolve(null);
                return;
            }

            const method = methods.shift();
            method().then(next);
        };

        next();
    });
}

export function waterfall<T>(methods: Array<(input: T) => Contract<T>>, input: T): Contract<T> {
    return new Contract<T>((resolve) => {
        const next = (result: T) => {
            if (!methods.length) {
                resolve(result);
                return;
            }

            const method = methods.shift();
            method(result).then(next);
        };

        next(input);
    });
}



// WEBPACK FOOTER //
// ./~/slotworks/utils/race-utils.ts